<template>
  <div id="mobileMenu">
    <div class="navBar">
      <el-menu
        ref="menu"
        class="el-menu"
        text-color="#fff"
        active-text-color="#fff"
        background-color="#00000000"
        mode="horizontal"
        :menu-trigger="'hover'"
      >
        <!--x-placement="top-start"-->
        <template v-for="(item, key) in structuredItems">
          <el-menu-item
            v-if="!item.isParent"
            :key="key"
            :index="item.index"
            :route="item"
            :style="menuItemStyle"
            @click="handleClick"
          >
            <div class="icon">
              <i
                v-if="item.icon && !item.icon.startsWith('custom-')"
                :class="item.icon"
              ></i>
              <i
                v-else-if="item.icon && item.icon.startsWith('custom-')"
                class="customIcon"
                :style="{backgroundImage:
                  `url(${require(`@/assets/icon/${item.icon.replace('custom-', '')}.png`)})`}"
              >
              </i>
              <i
                v-else
                :class="'el-icon-loading'"
              >
              </i>
            </div>
            <div class="name">
              {{ $t(item.label) }}
            </div>
          </el-menu-item>

          <el-submenu
            v-else
            ref="subMenu"
            :key="key"
            popper-class="mobileNavSubMenu"
            :index="item.index"
            x-placement="top-start"
            :style="menuItemStyle"
          >
            <template slot="title">
              <div
                class="icon"
                @click="handleClick({route: {name: item.label}})"
              >
                <i
                  v-if="item.icon && !item.icon.startsWith('custom-')"
                  :class="item.icon"
                ></i>
                <i
                  v-else-if="item.icon && item.icon.startsWith('custom-')"
                  class="customIcon"
                  :style="{backgroundImage:
                    `url(${require(`@/assets/icon/${item.icon.replace('custom-', '')}.png`)})`}"
                >
                </i>
                <i
                  v-else
                  :class="'el-icon-loading'"
                ></i>
              </div>
              <div
                class="name"
                @click="handleClick({route: {name: item.label}})"
              >
                {{ $t(`aside.${item.label}`) }}
              </div>
            </template>
            <el-menu-item
              v-for="(subItem, subKey) in item.children"
              :key="subKey"
              :disabled="subItem.disabled"
              :index="subItem.index"
              :route="subItem.route"
              @click="handleClick"
            >
              {{ $t(subItem.label) }}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      isMounted: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      userRole: (state) => state.user.user.role_type,
      isAC: (state) => state.user.profile.is_ac,
      currentSession: (state) => state.processStatus.process.session,
    }),

    env() {
      return process.env.VUE_APP_ENV;
    },

    myJourneyOpened() {
      if (!this.isMounted || !this.$refs.subMenu) { return false; }
      return this.$refs.subMenu[0].opened;
    },

    filteredItems() {
      // resolve doesn't expose children route
      // const dashboard = this.$router.resolve({ name: 'dashboard' });
      const dashboard = this.$router.options.routes.find((el) => el.path === '/dashboard');

      if (!dashboard) return [];

      const items = dashboard.children.filter((route) => {
        // in the item with nav menu options,
        // we keep the ones with no role restriction or with allowed roles
        if (route.meta && route.meta.navMenuOptions) {
          if (!route.meta.roles || route.meta.roles.includes(this.userRole)) {
            return true;
          }
        }
        return false;
      });
      return items;
    },

    structuredItems() {
      const formattedItems = {};

      this.filteredItems.forEach((el) => {
        // if index is something like 20-0, we don't display in menu
        // since it s a "main page" of submenu
        if (el.meta.navMenuOptions.index
          && el.meta.navMenuOptions.index.split('-')[1] === '0'
          && !el.meta.navMenuOptions.standAlone
        ) {
          return;
        }

        if (this.userRole === 'coach' && !this.isAC && el.meta.navMenuOptions.hideForNonAc) {
          return;
        }

        if (this.userRole === 'OA' && el.meta.navMenuOptions.cobrandingCheck) {
          if (!(this.user && this.user.organization && this.user.organization.allow_cobranding)) {
            return;
          }
        }

        if (el.meta.navMenuOptions.status
          && el.meta.navMenuOptions.status === 'dev') {
          // Dev router filter
          if (['dev', 'local'].includes(this.env)) {
            console.log('# Only shown in DEV!', el.name);
          } else {
            return;
          }
        }

        if (el.meta.navMenuOptions.status
          && el.meta.navMenuOptions.status === 'staging') {
          // Staging router filter
          if (['dev', 'local', 'staging'].includes(this.env)) {
            console.log('# Not shown in Prod!', el.name);
          } else {
            return;
          }
        }

        const { index } = el.meta.navMenuOptions;
        if (!el.meta.navMenuOptions.parent) {
          if (index) {
            formattedItems[index] = {
              index,
              label: el.meta.navMenuOptions.label,
              icon: el.meta.navMenuOptions.icon,
              route: { name: el.name },
              isParent: false,
            };

            if (el.meta.minSession) {
              formattedItems[index].disabled = el.meta.minSession > this.currentSession;
            }

            if (el.meta.navMenuOptions.status) {
              formattedItems[index].disabled = el.meta.navMenuOptions.status === 'closed';
            }
          }
        } else {
          const parentIndex = index.split('-')[0];
          if (!formattedItems[parentIndex]) {
            let icon;
            if (el.meta.navMenuOptions.parent === 'userSettings') {
              icon = 'el-icon-s-tools';
            } else if (['invoicesIn', 'invoiceLeaderOut'].includes(el.meta.navMenuOptions.parent)) {
              icon = 'custom-invoices';
            } else if (el.meta.navMenuOptions.parent === 'myLeaders') {
              icon = 'el-icon-s-custom';
            } else {
              icon = `custom-${el.meta.navMenuOptions.parent.toLowerCase()}`;
            }
            formattedItems[parentIndex] = {
              index: parentIndex,
              isParent: true,
              label: el.meta.navMenuOptions.parent,
              icon,
              children: {},
            };
          }

          const item = {
            index,
            label: el.meta.navMenuOptions.label,
            icon: el.meta.navMenuOptions.icon,
            route: { name: el.name },
          };

          if (el.meta.minSession) {
            item.disabled = el.meta.minSession > this.currentSession;
          }

          if (el.meta.navMenuOptions.status) {
            item.disabled = el.meta.navMenuOptions.status === 'closed';
          }

          formattedItems[parentIndex].children[index] = item;
        }
      });

      // If stand alone menu have some children at current role, remain only submenu
      Object.keys(formattedItems).forEach((item) => {
        const num = formattedItems[item].index;
        if (num.split('-')[1] * 1 === 0 && formattedItems[num.split('-')[0]]) {
          delete formattedItems[item];
        }
      });

      return formattedItems;
    },

    menuItemStyle() {
      const menuItemStyle = {
        width: `calc(100% / ${Object.keys(this.structuredItems).length})`,
      };
      return menuItemStyle;
    },
  },

  watch: {
    myJourneyOpened(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
      //   this.$router.push({ name: 'myJourney' }).catch((err) => {});
      }
    },
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    test(item) {
      console.log(item);
    },
    handleClick(item) {
      let name = '';
      if (item.route.name) {
        ({ name } = item.route);
      } else if (item.route.route.name) {
        ({ name } = item.route.route);
      } else {
        return;
      }
      this.$router.push({ name }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
#mobileMenu {
  background: #07122e;

  .el-menu {
    .el-menu-item,
    .el-submenu {
      display: block;
      text-align: center;
      padding-left: 0;
      padding-right: 0;
      padding-top: 5px;
      border: none;

      .icon,
      .name {
        max-height: 24px;
        line-height: 24px;

        i {
          margin: 0;
        }
      }

      .name {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 25px;
        word-break: break-word;
        white-space: pre-wrap;
        font-size: 11px;
        line-height: 11px;
      }

      .icon {
        .customIcon {
          display: inline-block;
          width: 29px;
          height: 15px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }

      &.is-opened {
        background-color: #c4c4c4;

        .icon {
          filter: brightness(10);
        }
      }

      &.is-active {
        .icon {
          filter: brightness(10);
        }
      }

      .el-submenu__title {
        background-color: transparent !important;
        padding: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.mobileNavSubMenu {
  background: #07122e;
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  position: fixed;
  bottom: 60px !important;
  top: unset !important;
  transition: top 200ms ease-in-out;

  // For only iOS Landscape
  @supports (-webkit-overflow-scrolling: touch) {
    @media (min-aspect-ratio: 1/1) {
      bottom: unset !important;
      top: calc(var(--vh, 1vh) * 100 - 300px) !important;
    }
  }

  .el-menu {
    .el-menu-item {
      height: 45px;
      line-height: 45px;

      &.is-active {
        border-bottom: none;
      }

      // It's render automatically from el-element So put it always
      &::before,
      &::after {
        display: table !important;
        content: '' !important;
      }
    }
  }
}
</style>
